import { useEffect } from "react";
import { PENDING_KEY, sendLanguageWithRetry } from "../apis/langSync";

/**
 * On startup, once userToken is available, re-send the language preference if a
 * previous send failed (langSyncPending flag is set). Also idempotently re-sends
 * the stored izzygo_lang so the server always converges to the current value.
 * Silent — no user-facing error under any circumstance.
 */
const useLangSyncOnStartup = (userToken) => {
  useEffect(() => {
    if (!userToken) return;

    const run = async () => {
      let lang;
      try {
        // Prefer the explicitly-pending language; fall back to the stored active lang.
        lang = localStorage.getItem(PENDING_KEY) || localStorage.getItem("izzygo_lang");
      } catch (_) {}

      if (!lang || lang === "en") {
        // 'en' is the backend default — no need to POST.
        try { localStorage.removeItem(PENDING_KEY); } catch (_) {}
        return;
      }

      await sendLanguageWithRetry(userToken, lang);
    };

    run();
  }, [userToken]); // Re-runs only when userToken changes (i.e., once after login)
};

export default useLangSyncOnStartup;
